export type FrictionType = "UX" | "Flow" | "Speed" | "Bug" | "Edge Case";
export type FrictionSeverity = "Low" | "Medium" | "High";
export type FrictionStatus = "New" | "Reviewed" | "In Progress" | "Resolved";

export interface FrictionEntry {
  id: string;
  userId: string;
  userRole: string;
  moduleName: string;
  screenName?: string;
  jobId?: string;
  frictionType: FrictionType;
  description: string;
  severity: FrictionSeverity;
  status: FrictionStatus;
  adminNotes?: string;
  createdAt: string;
}

export const FRICTION_TYPES: FrictionType[] = ["UX", "Flow", "Speed", "Bug", "Edge Case"];
export const FRICTION_SEVERITIES: FrictionSeverity[] = ["Low", "Medium", "High"];
export const FRICTION_STATUSES: FrictionStatus[] = ["New", "Reviewed", "In Progress", "Resolved"];

/** Map route prefixes to human-readable module names */
const ROUTE_MODULE_MAP: [string, string][] = [
  ["/intake-review", "Build Review"],
  ["/pipeline", "Pipeline"],
  ["/ordering-queue", "Ordering Queue"],
  ["/install-readiness", "Install Readiness"],
  ["/installer-dashboard", "Installer Dashboard"],
  ["/warehouse", "Warehouse"],
  ["/closeout", "QA / Closeout"],
  ["/scheduling", "Scheduling"],
  ["/issues", "Issues"],
  ["/service-tickets", "Service Tickets"],
  ["/jobs", "Jobs"],
  ["/reports", "Reports"],
  ["/settings", "Settings"],
  ["/opportunities", "Pipeline"],
  ["/customers", "Jobs"],
  ["/friction-log", "Friction Log"],
];

export function detectModuleFromRoute(pathname: string): string {
  if (pathname === "/") return "Dashboard";
  for (const [prefix, mod] of ROUTE_MODULE_MAP) {
    if (pathname.startsWith(prefix)) return mod;
  }
  return "Other";
}

/** Extract jobId from route like /jobs/JOB-005 */
export function detectJobIdFromRoute(pathname: string): string | undefined {
  const match = pathname.match(/\/jobs\/([^/]+)/);
  return match ? match[1] : undefined;
}

export const MODULE_NAMES = [
  "Dashboard", "Pipeline", "Build Review", "Ordering Queue",
  "Warehouse", "Install Readiness", "Installer Dashboard",
  "QA / Closeout", "Jobs", "Scheduling", "Issues",
  "Service Tickets", "Reports", "Settings", "Other",
] as const;
